<template>
  <footer
    class="flex items-center w-full bg-green h-8 pr-4 sm:pr-6 lg:pr-8 bg-green relative z-50"
  >
    <!-- User Account -->
    <div
      class="items-center text-white text-center"
      :class="$root.showMenu ? 'w-[150px]' : 'w-14'"
    >
      <inertia-link :href="route('app.profile.index')">
        <svg
          viewBox="0 0 40 40"
          xmlns="http://www.w3.org/2000/svg"
          class="block mx-auto w-5 h-5 stroke-current text-white cursor-pointer"
        >
          <g transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)">
            <path
              d="M6.750 9.750 A5.250 5.250 0 1 0 17.250 9.750 A5.250 5.250 0 1 0 6.750 9.750 Z"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
            <path
              d="M18.913,20.876a9.746,9.746,0,0,0-13.826,0"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
            <path
              d="M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
          </g>
        </svg>
      </inertia-link>

      <inertia-link
        :href="route('app.profile.index')"
        class="mt-1 text-sm"
        v-show="$root.showMenu"
      >
        Account
      </inertia-link>
    </div>

    <div class="h-full flex flex-grow justify-end items-center">
      <img
        src="/img/livefarm_logo_white.svg"
        alt="Livefarm"
        title="Livefarm"
        class="w-28 h-auto cursor-pointer"
      />
    </div>
  </footer>
</template>
